// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3947":"160fbbced54b63e4","4112":"a3ede44e6a0beb25","6401":"5f0b49598c86b522","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};